import { createBreakpoint } from 'react-use'

// These are Tailwind's default breakpoints
export const useBreakpoint = createBreakpoint({
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
})
